import { ProjectMenuButton } from '@components/App/ProjectMenuButton'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { MenuContent } from './components'
import { useProjectMenu } from './useProjectMenu'

export const ProjectMenu: React.FC = () => {
  const avatar = useSelector(migrationProjectSelector.getProjectAvatar)

  const { onClick } = useProjectMenu()

  return (
    <DropdownMenu.Root align="start" onClick={onClick} content={MenuContent}>
      <ProjectMenuButton avatar={avatar} />
    </DropdownMenu.Root>
  )
}
